import React, { FC } from 'react';
import { Input } from '@goldbely/explore-component-library';
import cls from 'classnames';
import type { Control, FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

import styles from './index.module.sass';

interface InputsProps {
  email: {
    errors: FieldErrors<FieldValues>;
    register?: UseFormRegister<FieldValues>;
  };
  isLoading: boolean;
  phone: {
    control: Control<FieldValues>;
    errors: FieldErrors<FieldValues>;
    register?: UseFormRegister<FieldValues>;
  };
  step: number;
}

const Inputs: FC<InputsProps> = ({ email, isLoading, phone, step }) => (
  <div className={styles.container}>
    <div
      className={cls( styles.form, {
        [styles.show]: step === 1,
      })}
    >
      <Input
        autoFocus
        disabled={isLoading}
        errors={email.errors}
        id="first-order-email"
        label="Email Address"
        placeholder="Email Address"
        register={email.register}
        rules={{
          required: 'Email address is required.',
          pattern: {
            message: 'Email address is not correct.',
            value: /^.+@.+\..+$/,
          },
        }}
        type="email"
      />
    </div>

    <div
      className={cls( styles.form, {
        [styles.show]: step === 2,
      })}
    >
      <Input
        control={phone.control}
        disabled={isLoading}
        errors={phone.errors}
        id="first-order-phone"
        label="Phone Number"
        placeholder="Mobile number"
        rules={{ required: 'Your mobile number is required.' }}
        type="tel"
      />
    </div>
  </div>
);

export default Inputs;
